import { Component, OnInit } from '@angular/core';
import { ToolsService } from '../../../../services/tools.service';

@Component({
  selector: 'app-plaid',
  templateUrl: './plaid.component.html',
  styleUrls: ['./plaid.component.css'],
})
export class PlaidComponent implements OnInit {
  linkToken: string | null = null;
  linkHandler: any;
  token: string = '';

  constructor(private plaidService: ToolsService) {}

  ngOnInit(): void {
    const userStr = sessionStorage.getItem('wOSUser') || '{}';
    const parsedUser = JSON.parse(userStr);
    this.token = parsedUser?.stsTokenManager?.accessToken || '';

    if (this.token) {
      this.fetchLinkToken();
    }
  }

  private fetchLinkToken(): void {
    this.plaidService.createLinkToken(this.token).then(
      (data) => {
        this.linkToken = data.link_token;
        this.initializePlaidLink();
      },
      (error) => {
        console.error('Error fetching Link token:', error);
      }
    );
  }

  private initializePlaidLink(): void {
    if (!this.linkToken) {
      return;
    }

    this.linkHandler = (window as any).Plaid.create({
      token: this.linkToken, 
      onSuccess: (publicToken: string) => {
        this.exchangePublicToken(publicToken);
      },
      onExit: () => {}
    });
  }

  openPlaidLink(): void {
    if (this.linkHandler) {
      this.linkHandler.open();
    }
  }

  private exchangePublicToken(publicToken: string): void {
    this.plaidService.exchangePublicToken(publicToken, this.token).then(
      () => {},
      (error) => {
        console.error('Error exchanging public token:', error);
      }
    );
  }
}
